// tslint:disable: no-empty
import React, { Context, createContext, PropsWithChildren, useCallback, useContext, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { callApi, TApiResponse } from '../api'
import { useExpertsContext } from '../experts'
import { ISearch, TSearchActions, TSearchResult } from '../types'
import { useChannelContext } from '../channel'

/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-empty-function */

const initialSearchState: ISearch = {
	results: [],
	value: '',
	loading: false,
}

const SearchContext: Context<{
	search: ISearch
	actions: TSearchActions
}> = createContext({
	search: initialSearchState,
	actions: {
		search: (value: string) => {},
		clear: () => {},
		select: (res: TSearchResult) => {},
		setValue: (value: string) => {},
	},
})

export const SearchProvider = (props: PropsWithChildren<{}>) => {
	const history = useHistory()

	const [loading, setLoading] = useState<boolean>(false)
	const [error, setProviderError] = useState<string | null>(null)
	const [results, setSearchResults] = useState<TSearchResult[]>([])
	const [value, setValue] = useState<string>('')
	const { channel } = useChannelContext()

	const { actions: expertsActions } = useExpertsContext()

	const fetchSearchResults = async (searchValue: string) => {
		setLoading(true)

		const searchResultsResponse: TApiResponse = await callApi('search/fast', {
			query: { search: searchValue, channel: channel.selectedChannelId },
		})

		const { data } = searchResultsResponse.payload

		if (searchResultsResponse.ok) {
			setLoading(false)
			setProviderError(null)
			setSearchResults(data.results)
		} else {
			setLoading(false)
			setProviderError(data.message || 'Cannot get Search Results!')
		}
	}

	const clearSearchResults = () => {
		setSearchResults([])
	}

	const selectSearchResult = (searchResult: TSearchResult) => {
		history.push(`/expert/${searchResult.slug}`)
	}

	const search = useCallback(fetchSearchResults, [channel.selectedChannelId])
	const clear = useCallback(clearSearchResults, [])
	const select = useCallback(selectSearchResult, [expertsActions, history])

	const actions: TSearchActions = {
		search,
		clear,
		select,
		setValue,
	}

	return (
		<SearchContext.Provider value={{ search: { value, results, loading, error }, actions }}>
			{props.children}
		</SearchContext.Provider>
	)
}

export const useSearchContext: () => {
	search: ISearch
	actions: TSearchActions
} = () => {
	return useContext(SearchContext)
}
